import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, Users, BookOpen, Music, 
  BarChart2, Settings, LogOut, HelpCircle,
  MessageSquare, LineChart, Lock, Folder
} from 'lucide-react';
import '../styles/sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  const navItems = [
    { path: '/', icon: Home, label: 'Dashboard' },
    { path: '/analytics', icon: LineChart, label: 'Analytics' },
    { path: '/student-progress', icon: BarChart2, label: 'Student Progress' },
    { path: '/students', icon: Users, label: 'Students' },
    { path: '/user-access', icon: Lock, label: 'User Access' },
    { path: '/folder-access', icon: Folder, label: 'Folder Access' },
    { path: '/quiz', icon: BookOpen, label: 'Quiz Management' },
    { path: '/audio', icon: Music, label: 'Quiz Audios' },
    { path: '/doubts', icon: MessageSquare, label: 'Student Doubts' },
  ];

  const handleLogout = () => {
    // Add logout logic here
    console.log('Logging out...');
  };

  // Close sidebar when clicking outside on mobile
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      {/* Mobile backdrop */}
      {isOpen && (
        <div 
          className="sidebar-backdrop"
          onClick={handleBackdropClick}
          aria-hidden="true"
        />
      )}
      <aside 
        className={`sidebar ${isOpen ? 'open' : ''}`} 
        role="navigation" 
        aria-label="Main Navigation"
      >
        {/* Add close button for mobile */}
        <button 
          className="close-sidebar"
          onClick={onClose}
          aria-label="Close menu"
        >
          ×
        </button>
        <div className="sidebar-header">
          {/* <img 
            src="/cmpnylogo.jpg" 
            alt="Company Logo" 
            className="sidebar-logo"
          /> */}
          <h1 className="sidebar-title">Admin Panel</h1>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-list">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                    aria-current={location.pathname === item.path ? 'page' : undefined}
                  >
                    <Icon className="nav-icon" aria-hidden="true" />
                    <span className="nav-label">{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* <div className="sidebar-footer">
          <button 
            className="help-button"
            aria-label="Get Help"
          >
            <HelpCircle className="footer-icon" />
            <span>Help & Support</span>
          </button>

          <button 
            className="settings-button"
            aria-label="Open Settings"
          >
            <Settings className="footer-icon" />
            <span>Settings</span>
          </button>

          <button 
            className="logout-button"
            onClick={handleLogout}
            aria-label="Log Out"
          >
            <LogOut className="footer-icon" />
            <span>Logout</span>
          </button>
        </div> */}
      </aside>
    </>
  );
};

export default Sidebar; 
